import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import KlaviyoForm from "@/features/save-user/Form";

const SaveUserForm = () => {
    const [containers, setContainers] = useState([]);
    const modalSelector = '.CampaignType--popup.Campaign--css';

    const data = {
        klaviyoEvent: window.mozartSaveUserData[window.mozartSaveUserData.index] ,
    }

    useEffect(() => {
        const updateContainers = () => {
            setContainers(Array.from(document.querySelectorAll('.mozart-save-user')));
        };

        updateContainers();

        const observer = new MutationObserver(mutations => {
            for (const mutation of mutations) {
                if (Array.from(mutation.addedNodes).some(node => node.matches && node.matches(modalSelector))) {
                    updateContainers();
                }
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });

        return () => observer.disconnect();
    }, []);

    return (
        <>
            {containers.map((container, index) => (
                createPortal(
                    <KlaviyoForm
                        key={index}
                        data={data}
                    />,
                    container
                )
            ))}
        </>
    );
};

export default SaveUserForm;
